export const SHOPPING_QUOTE_TOTAL_QUANTITY = 'shoppingQuoteTotalQuantity'
export const ADDING_TO_SHOPPING_QUOTE = 'addingToShoppingQuote'
export const INVENTORY_STATUS_LOADED = 'inventoryStatusLoaded'
export const APPOINTMENT_SCHEDULING_IN_PROGRESS = 'appointmentSchedulingInProgress'
